import { render, staticRenderFns } from "./PurposeComponent.vue?vue&type=template&id=b3854026&scoped=true&"
import script from "./PurposeComponent.vue?vue&type=script&lang=js&"
export * from "./PurposeComponent.vue?vue&type=script&lang=js&"
import style0 from "./PurposeComponent.vue?vue&type=style&index=0&id=b3854026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3854026",
  null
  
)

export default component.exports